module.exports = __webpack_public_path__ + "img/perzeption-reduced-test.5b2563a8.svg";